<template>
    <div name="select-box-modal" class="wrapper">
        <div class="modal">
            <div class="touch" @click="onClose(selectedIndex)">

            </div>
            <div class="contents">
                <span class="title">{{ title }}</span>
                <div style="margin-top: 30px; width: 100%;" v-if="selectList">
                    <div v-for="(select, index) in selectList" :key="index">
                        <div class="row" @click="onClose(index)" v-if="select !== ''" >
                            <span class="option-text">{{ select }}</span>
                            <img style="width: 14.29px;" v-if="selected == index" src="../../assets/selected.png" />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'selectBoxModal',
    props: ['selectList', 'selectedIndex', 'title'],
    data: function()
    {
        return {
            selected: ''
        }
    },  
    mounted: function()
    {
        if(this.selectList != null)
        {
            this.selected = this.selectedIndex;
        }
    },
    methods: {
        onClose: function(index)
        {
            this.$emit('closeModal', index);
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 10;
        bottom: 0;
        box-sizing: border-box;
    }
    .touch {
        height: calc(100vh - 350px);
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        height: 350px;
        width: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding-top: 30px;
        padding-left: 18px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }
    .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 20px;
        padding-right: 16px;
        box-sizing: border-box;
    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 100% */
    }
    .option-text {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 110% */
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/SelectBoxModal.vue